import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { selectUserRoles, selectIsLoading } from '../../store/auth/auth.selectors';

export const adminGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(selectUserRoles),
    store.select(selectIsLoading),
  ]).pipe(
    // Wait until auth hydration finishes (isLoading flips to false)
    filter(([, isLoading]) => !isLoading),
    take(1),
    map(([roles]) => {
      if (roles.includes('admin')) return true;
      router.navigate(['/dashboard']);
      return false;
    }),
  );
};
